<template>
  <base-dialog-button :isOpen="dialogOpen" @closeDialog="toggleDialog" :size="mobileVersion ? 'fs' : 'lg-fix-h'">
    <template slot="header">
      <div class="h-16 bg-secondary flex items-center justify-between text-white px-4">
        <div class="flex items-center">
          <h2 class="font-bold ml-2">{{ $t('invoices.dialogs.upload_invoice_header') }}</h2>
        </div>
        <span class="cursor-pointer" @click="toggleDialog">
          <base-button-icon name="cross" size="xs" iconSize="sm" mode="secondary" />
        </span>
      </div>
    </template>
    <template slot="main">
      <div class="form-wrapper p-4 overflow-x-auto overflow-y-auto"
        :style="mobileVersion ? 'height: 80vh;' : 'height: 60vh;'">
        <el-form :model="form" ref="ruleForm" :rules="rules">
          <div class="lg:mb-2" v-if="[3, 8].includes(role)">
            <label
              class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon />{{ $t('clients.entity_name') }}</label>
            <el-form-item prop="ClienteID">
              <base-el-select class="w-full" :options="clientes" v-model="form.ClienteID" filterable clearable @change="handleChangeClienteId" />
            </el-form-item>
          </div>

          <div class="lg:mb-2 flex">
            <el-switch class="switch-text break-normal both-switch" 
                v-model="EsRecibidas" 
                :active-text="$t('invoices.received')" 
                :inactive-text="$t('invoices.issued')"
                inactive-color="var(--primary-800)" />
            <!-- <base-tooltip-icon v-if="!hasIOCRModule" size="sm" :content="$t('tooltip.received_edasaps_warn')" class="ml-2 " /> -->
          </div>

          <div class="mt-5">
            <section v-if="EsRecibidas">
              <div class="lg:mb-2" v-if="form.ClienteID">
                <div class="flex">
                  <label
                  class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon />{{ $t('app.forma_recepcion') }}</label>
                  <base-tooltip-icon v-if="!hasAutoFacturaModule || !hasIOCRModule" size="sm" :content="receivedPgeTooltip" class="ml-2 " />
                </div>
                <el-form-item prop="pgeType">
                  <base-el-select class="w-full" :options="pgeTypesRecepcion" v-model="form.pgeType" filterable/>
                </el-form-item>
              </div>
              <div class="lg:mb-2" v-if="isOCRPGE && form.ClienteID">
                <label
                  class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon />{{  $t('invoices.cif_receptor') }}</label>
                <el-form-item prop="CifEmpresa">
                  <base-el-select class="w-full" :options="CifsEmpresaAPS" v-model="form.CifEmpresa" filterable clearable />
                </el-form-item>
              </div>
              <div class="lg:flex" v-if="form.ClienteID && ( !isOCRPGE || form.CifEmpresa)">
                <div class="max-w-md">
                  <div class="flex items-center mb-1">
                    <label class="text-sm font-semibold text-secondary-600 block"><base-obligatory-icon />{{
                     isOCRPGE ? $t('invoices.pdf_invoice') :
                      $t('invoices.doc_facturae') }}</label>
                    <base-tooltip-icon size="sm" :content="extensionTooltipFacturaApsMessage" class="ml-2 " />
                  </div>
                  <el-form-item prop="fileMain" ref="fileMainRef">
                    <div @dragenter="e => e.preventDefault()" @dragover="e => e.preventDefault()" @drop.prevent.stop="onFileMainDrop">
                      <Upload ref="uploadReceivedMain" id="fileMainSelector" class="bg-white dark:bg-darkblue-900"
                        :class="[isLower1024 ? 'custom-upload-cert' : 'custom-upload ']" :accept="receivedAcceptFiles"
                        drag action="#" :auto-upload="false" :on-remove="handleRemoveMain" :limit="ocrUploadLimitComputed" multiple
                        :on-change="handleChangeMain" :on-exceed="handleOnExceedMain" :file-list="form.fileMain">
                        <i class="el-icon-upload"></i>
                        <p v-if="form.fileMain.length" slot="default" class="el-upload__text"><em>{{ this.fileNameMain }}</em></p>
                        <div v-else slot="default" class="el-upload__text" v-html="$tc('app.upload_default_no_file_text', ocrUploadLimitComputed)"></div>
                        <upload-file-item slot="file" slot-scope="{file}" :file="file" :actions="[{name: 'addattachment-border', handler: selectFile, show: showAddAttachments /* && false */}]"
                          :hide-expand-action="file.validations && file.validations.some(v => v.type === ErrorType.DUPLICATED_FILE)" :deep="2" custom="!max-h-fit" @remove="handleRemoveMain" @click="selectFile" reverse-colors />
                      </Upload>
                    </div>
                  </el-form-item>
                </div>
                <div v-if="/* !multiSend */selectedFile && !disableAdjuntos" class="file-attachments-container max-w-md">
                  <div class="flex items-center mb-1" :style="{ width: itemWidth }">
                    <base-obligatory-icon class="invisible" />
                    <el-tooltip placement="top-end">
                      <div slot="content" class="max-w-sm max-h-500p overflow-auto">
                        {{ selectedFile.path || selectedFile.name }}
                      </div>
                      <span class="tooltip-icon__icon-wrap truncate">
                        <label class="text-sm font-semibold text-secondary-600 block truncate">{{ attachmentsText }}</label>
                      </span>
                    </el-tooltip>
                    <base-tooltip-icon-multiple size="sm" :content="extensionTooltipMessage" class="ml-2 " />
                  </div>
                  <div ref="upload-file-wrap" class="px-2" :style="{ width: 'fit-content' }">
                    <el-form-item prop="file" ref="fileRef">
                      <div @dragenter="e => e.preventDefault()" @dragover="e => e.preventDefault()" @drop.prevent.stop="onFileDrop">
                        <Upload ref="uploadReceivedMain" id="fileSelector" class="bg-white dark:bg-darkblue-900" :show-file-list="false"
                          :class="[isLower1024 ? 'custom-upload-cert' : 'custom-upload ']" :accept="acceptAdjuntosExternos" drag
                          multiple action="#" :auto-upload="false" :on-remove="handleRemove" :limit="maxFilesAdjWithRequired"
                          :on-change="handleChange" :on-exceed="handleOnExceed" :file-list="form.file" :disabled="form.fileMain.length > 1 && false ">
                          <i class="el-icon-upload"></i>
                          <p v-if="form.file.length" class="el-upload__text"><em>{{ fileName }}</em></p>
                          <div v-else class="el-upload__text" v-html="$tc('app.upload_default_no_file_text', maxFilesAdjWithRequired)"></div>
                        </Upload>
                        <div v-for="file in expandedFiles" :key="file.linkid + file.uid">
                          <upload-file-list v-if="file.linkid === selectedFile.linkid && file.uid === selectedFile.uid" :files="attachments.filter(efile => (efile.linkedfile && efile.linkedfile.linkid === file.linkid && efile.linkedfile.uid === file.uid))"
                            :actions="[{name: 'error', handler: clearRequiredFile, show: efile => efile.required && !efile.IsAlreadyProvided && !!efile.raw}, {name: 'addattachment-border', handler: selectRequiredFile, show: efile => efile.required && !efile.IsAlreadyProvided}]" :hide-default-item-actions-callback="efile => efile.required || efile.IsAlreadyProvided" 
                            :hide-status-item-callback="efile => !efile.required" @remove-file="handleRemove" :item-click-listener-callback="efile => efile.required && !efile.IsAlreadyProvided ? {click: selectRequiredFile} : {}" />
                        </div>
                      </div>
                    </el-form-item>
                  </div>
                </div>
                <div v-if="form.file && form.file.length > 0" class="all-attachments-container w-full">
                  <div class="flex items-center mb-1 invisible">
                    <label class="text-sm font-semibold text-secondary-600 block w-0 truncate">{{ allAttachmentsText }}</label>
                  </div>
                  <upload-file-list key="attachments-list" class="grid gap-4" :class="allAttachmentsListClass" :files="attachments" max-height="calc(100% - 20px)" :hide-status-item-callback="efile => !efile.required" hide-default-actions />
                </div>
              </div>
              <el-switch v-if="multiSend" class="switch-text break-normal" v-model="form.sendMail" :active-text="$t('app.send_mail')"></el-switch>
            </section>
            <section v-else>
              <div class="lg:mb-2" v-if="form.ClienteID">
                <label
                  class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon />{{ $t('app.pge_type') }}</label>
                <el-form-item prop="pgeType">
                  <base-el-select class="w-full" :options="pgeTypes" v-model="form.pgeType" filterable clearable />
                </el-form-item>
              </div>
              <div class="lg:flex files-container" v-if="form.pgeType">
                <div class="main-files-container max-w-md">
                  <div class="flex items-center mb-1">
                    <label class="text-sm font-semibold text-secondary-600 block"><base-obligatory-icon />{{
                      $t('invoices.doc_facturae') }}</label>
                    <base-tooltip-icon size="sm" :content="extensionTooltipFacturaeMessage" class="ml-2 " />
                  </div>
                  <div class="px-2">
                    <el-form-item prop="fileMain" ref="fileMainRef">
                      <div @dragenter="e => e.preventDefault()" @dragover="e => e.preventDefault()" @drop.prevent.stop="onFileMainDrop">
                        <Upload ref="uploadMain" id="fileMainSelector" class="bg-white dark:bg-darkblue-900"
                        :class="[isLower1024 ? 'custom-upload-cert' : 'custom-upload ']" :accept="pgeAcceptFiles"
                        drag action="#" :auto-upload="false" :on-remove="handleRemoveMain" multiple :limit="pgeUploadLimitComputed"
                        :on-change="handleChangeMain" :on-exceed="handleOnExceedMain" :file-list="form.fileMain">
                        <i class="el-icon-upload"></i>
                        <p v-if="form.fileMain.length" slot="default" class="el-upload__text"><em>{{ this.fileNameMain }}</em></p>
                        <div v-else slot="default" class="el-upload__text" v-html="$tc('app.upload_default_no_file_text', pgeUploadLimitComputed)"></div>
                        <upload-file-item slot="file" slot-scope="{file}" :file="file" :actions="[{name: 'addattachment-border', handler: selectFile, show: showAddAttachments /* && false */}]"
                          :hide-expand-action="file.validations && file.validations.some(v => v.type === ErrorType.DUPLICATED_FILE)" :deep="2" custom="!max-h-fit" @remove="handleRemoveMain" @click="selectFile" reverse-colors />
                        </Upload>
                      </div>
                    </el-form-item>
                  </div>
                </div>
                <div v-if="/* !multiSend */selectedFile" class="file-attachments-container max-w-md">
                  <div class="flex items-center mb-1" :style="{ width: itemWidth }">
                    <base-obligatory-icon class="invisible" />
                    <el-tooltip placement="top-end">
                      <div slot="content" class="max-w-sm max-h-500p overflow-auto">
                        {{ selectedFile.path || selectedFile.name }}
                      </div>
                      <span class="tooltip-icon__icon-wrap truncate">
                        <label class="text-sm font-semibold text-secondary-600 block truncate">{{ attachmentsText }}</label>
                      </span>
                    </el-tooltip>
                    <base-tooltip-icon-multiple size="sm" :content="extensionTooltipMessage" class="ml-2 " />
                  </div>
                  <div ref="upload-file-wrap" class="px-2" :style="{ width: 'fit-content' }">
                    <el-form-item prop="file" ref="fileRef">
                      <div @dragenter="e => e.preventDefault()" @dragover="e => e.preventDefault()" @drop.prevent.stop="onFileDrop">
                        <Upload ref="upload" id="fileSelector" class="bg-white dark:bg-darkblue-900" :show-file-list="false"
                          :class="[isLower1024 ? 'custom-upload-cert' : 'custom-upload ']" :accept="acceptAdjuntosExternos" drag
                          multiple action="#" :auto-upload="false" :on-remove="handleRemove" :limit="maxFilesAdjWithRequired"
                          :on-change="handleChange" :on-exceed="handleOnExceed" :file-list="form.file" :disabled="form.fileMain.length > 1 && false ">
                          <i class="el-icon-upload"></i>
                          <p v-if="form.file.length" class="el-upload__text"><em>{{ fileName }}</em></p>
                          <div v-else class="el-upload__text" v-html="$tc('app.upload_default_no_file_text', maxFilesAdjWithRequired)"></div>
                        </Upload>
                        <div v-for="file in expandedFiles" :key="file.linkid + file.uid">
                          <upload-file-list v-if="file.linkid === selectedFile.linkid && file.uid === selectedFile.uid" :files="attachments.filter(efile => (efile.linkedfile && efile.linkedfile.linkid === file.linkid && efile.linkedfile.uid === file.uid))"
                            :actions="[{name: 'error', handler: clearRequiredFile, show: efile => efile.required && !efile.IsAlreadyProvided && !!efile.raw}, {name: 'addattachment-border', handler: selectRequiredFile, show: efile => efile.required && !efile.IsAlreadyProvided}]" :hide-default-item-actions-callback="efile => efile.required || efile.IsAlreadyProvided" 
                            :hide-status-item-callback="efile => !efile.required" @remove-file="handleRemove" :item-click-listener-callback="efile => efile.required && !efile.IsAlreadyProvided ? {click: selectRequiredFile} : {}" />
                        </div>
                      </div>
                    </el-form-item>
                  </div>
                </div>
                <div v-if="form.file && form.file.length > 0" class="all-attachments-container w-full">
                  <div class="flex items-center mb-1 invisible">
                    <label class="text-sm font-semibold text-secondary-600 block w-0 truncate">{{ allAttachmentsText }}</label>
                  </div>
                  <upload-file-list key="attachments-list" class="grid gap-4" :class="allAttachmentsListClass" :files="attachments" max-height="calc(100% - 20px)" :hide-status-item-callback="efile => !efile.required" hide-default-actions />
                </div>
              </div>
              <div class="lg:mb-2" v-if="isZCPGE">
                <label
                  class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon />{{ $t('invoices.cif_emisor') }}</label>
                <el-form-item prop="CifEmpresa">
                  <base-el-select class="w-full" :options="CifsEmpresa" v-model="form.CifEmpresa" filterable clearable :loading="isCifEmisorLoading" :loading-text="cifEmisorLoadingText" />
                </el-form-item>
              </div>

              <div class="lg:mb-2">
                <el-switch v-if="form.pgeType" class="switch-text break-normal" v-model="form.sendAuto" :active-text="$t('app.send_auto')"></el-switch>&nbsp;
                <el-switch v-if="multiSend" class="switch-text break-normal" v-model="form.sendMail" :active-text="$t('app.send_mail')"></el-switch>
              </div>
            </section>
          </div>
        </el-form>
      </div>
    </template>
    <template slot="footer">
      <div class="flex flex-row w-full justify-between">
        <base-button class="w-full mx-2" @click="toggleDialog" mode="secondary-phantom-blue" :text="$t('app.cancel')" />
        <base-button :disabled="disableSubmit" :loading="isLoadingUpdate" mode="secondary-phantom-blue" class="w-full mx-2"
        :text="$tc('invoices.dialogs.upload_invoice', 1)" @click="uploadInvoice('ruleForm')" />
      </div>
    </template>
  </base-dialog-button>
</template>

<script>
import { getClients } from '@/services/clients/getClients'
import { getAvailableCifsAPS } from '@/services/companies/getAvailableCifsAPS'
import { getAllCompanies } from '@/services/companies/getAllCompanies'
import { getTipoEsquema } from '@/services/invoices/getTipoEsquema'
import { subirFactura } from '@/services/invoices/subirFactura'
import { subirFacturaAPS } from '@/services/invoices/subirFacturaAPS'
import { subirFacturaRecibida } from '@/services/invoices/subirFacturaRecibida'

import { Upload } from 'element-ui'
import { i18n } from '@/i18n'
import { EXTENSIONES_ADJ_EXTERNOS, EXTENSIONES_ADJ_EXTERNOS_FACEB2B } from '@/config/extensiones-adj-externos'
import { EXTENSIONES_FACTURAE } from '@/config/extensiones-facturae'
import UploadFileItem from '@/components/UploadFileItem.vue'
import UploadFileList from '@/components/UploadFileList.vue'

const WarningType = {
  /** @type {0} */ MIXED_WARNING: 0,
  /** @type {1} */ MISSING_CIF: 1,
  /** @type {2} */ MISSING_ATTACHMENT: 2,
}
const ErrorType = {
  /** @type {0} */ GENERIC_ERROR: 0,
  /** @type {1} */ API_RESPONSE_ERROR: 1,
  /** @type {2} */ SCHEMA_VALIDATION_ERROR: 2,
  /** @type {3} */ EMPTY_INVOICE_FILE: 3,
  /** @type {4} */ INVALID_INVOICE_COUNT_ERROR: 4,
  /** @type {5} */ DUPLICATED_FILE: 5,
  /** @type {1} */ API_TIMEOUT_ERROR: 6,
}

export default
{
  name: 'upload-invoice-dialog',
  components: {
    Upload,
    UploadFileItem,
    UploadFileList,
  },
  props: {
    dialogOpen: {
      type: Boolean,
      default: false
    },
    mobileVersion: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      WarningType,
      ErrorType,
      isLoadingUpdate: false,
      loading: false,
      isOpen: this.dialogOpen,
      itemWidth: 'fit-content',
      issuedForm: {
        ClienteID: '',
        sendAuto: false,
        sendMail: false,
        pgeType: '',
        fileMain: [],
        file: [],
        CifEmpresa: '',
      },
      receivedForm: {
        ClienteID: '',
        CifEmpresa: '',
        fileMain: [],
        file: [],
        sendMail: false,
        pgeType: '',
      },
      selectedFile: null,
      ocrUploadLimit: 30,
      pgeUploadLimit: 30,
      OldClienteId: '',
      OldClienteIdAPS: '',
      maxFilesAdj: 5,
      maxSizeFile: 7340032, // Bytes (7MB)
      maxApsSizeFile: 7340032, // Bytes (7MB)
      clientes: [],
      CifsEmpresa: [],
      CifsEmpresaAPS: [],
      EsRecibidas: false,
      extensionesAdjuntosPermitidas: EXTENSIONES_ADJ_EXTERNOS,
      extensionesAdjuntosFaceb2b: EXTENSIONES_ADJ_EXTERNOS_FACEB2B,
      extensionesFacturaePermitidas: EXTENSIONES_FACTURAE,
      issuedRules: {
        ClienteID: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: ['blur', 'change'],
          }
        ],
        pgeType: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: ['blur', 'change'],
          }
        ],
        fileMain: [
          {
            required: true,
            trigger: ['blur', 'change'],
            validator: (rule, value, callback) => {
              if (!this.fileNameMain) {
                callback(new Error(i18n.t('app.fill_data')))
              } else {
                callback()
              }
            }
          },
          {
            required: true,
            trigger: ['blur', 'change'],
            validator: (rule, value, callback) => {
              if (!this.fileNameMain || this.fileNameMain.length < 5 || !this.fileNamesMain.every(name => ['XML', 'XSIG', 'TXT', 'ZIP'].includes(this.getExtensionFromFileName(name).toUpperCase()))) {
                callback(new Error(i18n.t('validation.not_single_valid_extension', { ext: this.listToCommaString(['.xml', '.xsig', '.txt'], true) })))
              } else {
                callback()
              }
            }
          },
          {
            required: true,
            trigger: ['blur', 'change'],
            validator: (rule, value, callback) => {
              const exts = this.fileNamesMain.map(name => this.getExtensionFromFileName(name).toUpperCase())
              if (exts.some(x => x === 'ZIP')) {
                if (exts.length > 1) {
                  callback(new Error(i18n.t('validation.onlyonce_zip')))
                } else {
                  callback()
                }
              } else if (!exts.every(x => this.extensionesFacturaePermitidas.includes(x))) {
                callback(new Error(i18n.t('validation.not_single_valid_extension', { ext: this.listToCommaString(['.xml', '.xsig', '.txt'], true) })))
              } else {
                callback()
              }
            }
          }
        ],
        file: [
          {
            required: true,
            trigger: ['blur', 'change'],
            validator: (rule, value, callback) => {
              if (this.fileName) {
                let totalSize = 0
                this.form.file.forEach(x => {
                  totalSize = totalSize + x.size
                })
                if (totalSize > this.maxSizeFile) {
                  callback(new Error(i18n.t('validation.exceed_size_files_total') + ' (' + this.maxMBAdj + ' MB)'))
                } else {
                  callback()
                }
              } else {
                callback()
              }
            }
          },
          {
            required: true,
            trigger: ['blur', 'change'],
            validator: (rule, value, callback) => {
              let invalidExtension = false
              this.form.file.forEach(archivo => {
                const extension = this.getExtensionFromFileName(archivo.name).toUpperCase()
                if (this.form.pgeType === 'FACEB2B') {
                  if (!this.extensionesAdjuntosFaceb2b.includes(extension)) {
                    invalidExtension = true
                  }
                  if (extension === 'ZIP' && this.form.file.length > 1) {
                    invalidExtension = true
                  }
                } else {
                  if (!this.extensionesAdjuntosPermitidas.includes(extension)) {
                    invalidExtension = true
                  }
                }
              })
              if (invalidExtension) {
                callback(new Error(this.extensionRuleMessage))
              } else {
                callback()
              }
            }
          },
        ],
        CifEmpresa: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: ['blur', 'change'],
          }
        ],
      },
      receivedRules: {
        ClienteID: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: ['blur', 'change'],
          }
        ],
        CifEmpresa: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: ['blur', 'change'],
          }
        ],
        fileMain: [
          {
            required: true,
            trigger: ['blur', 'change'],
            validator: (rule, value, callback) => {
              if (!this.fileNameMain) {
                callback(new Error(i18n.t('app.fill_data')))
              } else {
                callback()
              }
            }
          },
          {
            required: true,
            trigger: ['blur', 'change'],
            validator: (rule, value, callback) => {
              if (this.fileNameMain) {
                const totalSize = this.form.fileMain.map(x => x.size).reduce((a, b) => a + b, 0)
                if (totalSize > this.maxSizeFile) {
                  callback(new Error(i18n.t('validation.exceed_size_files_total') + ' (' + this.maxMBAdj + ' MB)'))
                } else {
                  callback()
                }
              }
            }
          },
          {
            required: true,
            trigger: ['blur', 'change'],
            validator: (rule, value, callback) => {
              const validExts = [...(this.receivedForm.pgeType === 'OCR' ? ['PDF'] : ['XML', 'XSIG']), 'ZIP']
              if (!this.fileNameMain || this.fileNameMain.length < 5 || !this.fileNamesMain.every(name => validExts.includes(this.getExtensionFromFileName(name).toUpperCase()))) {
                callback(new Error(i18n.t('validation.not_valid_extension', { exts: validExts })))
              } else {
                callback()
              }
            }
          },
          {
            required: true,
            trigger: ['blur', 'change'],
            validator: (rule, value, callback) => {
              const exts = this.fileNamesMain.map(name => this.getExtensionFromFileName(name).toUpperCase())
              if (exts.some(x => x === 'ZIP')) {
                if (exts.length > 1) {
                  callback(new Error(i18n.t('validation.onlyonce_zip')))
                } else {
                  callback()
                }
              } else if (this.receivedForm.pgeType === 'OCR' && !exts.every(x => x === 'PDF')) {
                callback(new Error(i18n.t('validation.not_single_valid_extension', { ext: '.pdf' })))
              } else if (this.receivedForm.pgeType !== 'OCR' && !exts.every(x => ['XML', 'XSIG'].includes(x))) {
                callback(new Error(i18n.t('validation.not_single_valid_extension', { ext: this.listToCommaString(['.xml', '.xsig'], true) })))
              } else {
                callback()
              }
            }
          },
        ],
        file: [
          {
            required: true,
            trigger: ['blur', 'change'],
            validator: (rule, value, callback) => {
              if (this.receivedForm.pgeType === 'OCR' && this.form.file.length > 0) {
                callback(new Error(i18n.t('validation.no_attachments_permited')))
              } else {
                callback()
              }
            }
          },
          {
            required: true,
            trigger: ['blur', 'change'],
            validator: (rule, value, callback) => {
              if (this.fileName) {
                let totalSize = 0
                this.form.file.forEach(x => {
                  totalSize = totalSize + x.size
                })
                if (totalSize > this.maxSizeFile) {
                  callback(new Error(i18n.t('validation.exceed_size_files_total') + ' (' + this.maxMBAdj + ' MB)'))
                } else {
                  callback()
                }
              } else {
                callback()
              }
            }
          },
          {
            required: true,
            trigger: ['blur', 'change'],
            validator: (rule, value, callback) => {
              if (this.form.file.some(archivo => !this.extensionesAdjuntosPermitidas.includes(this.getExtensionFromFileName(archivo.name).toUpperCase()))) {
                callback(new Error(this.extensionRuleMessage))
              } else {
                callback()
              }
            }
          },
        ]
      },
      schemasFiles: {
        TXT: 0,
        EFR: 0,
        ZCPGE: 0,
        ESQZCPGE: 0,
        ROCHLING: 0,
        FACTURAE: 0,
        NO_VALID: 0,
      },
    }
  },
  watch: {
    // Inicializar al abrir el componente
    dialogOpen: function (value, oldValue) {
      if (value) this.initialiceData()
    },
    selectedFile: function (value, oldValue) {
      if (value && !oldValue) {
        this.$nextTick(this.calculateItemWidth)
      }
    },
    EsRecibidas: async function (value, oldValue) {
      if (value) {
        if (this.form.ClienteID && this.form.ClienteID !== this.OldClienteIdAPS) {
          this.updateClientAPSCifs(this.form.ClienteID)
        }
        this.OldClienteIdAPS = this.form.ClienteID
      } else {
        if (this.form.ClienteID && this.form.ClienteID !== this.OldClienteId) {
          this.updateClientCifs(this.form.ClienteID)
        }
        this.OldClienteId = this.form.ClienteID
      }
      this.resetIssuedForm()
      this.resetReceivedForm()
    },
    'schemasFiles.ZCPGE': async function (value, oldValue) {
      if (value > oldValue && value > 0 && (!this.isSuperAdminOrDistributor || this.form.ClienteID)) {
        this.updateClientCifs(this.form.ClienteID)
      }
    },
    'form.CifEmpresa': function (value, oldValue) {
      if (value !== oldValue) {
        this.updateWarningStatus(WarningType.MISSING_CIF, !!value, file => file.esquema === 'ZCPGE')
      }
    },
    'receivedForm.pgeType': function (value, oldValue) {
      if (value !== oldValue && (value === 'OCR' || oldValue === 'OCR')) {
        this.selectedFile = null
        this.resetReceivedFormFiles()
      }
    }
  },
  mounted: async function () {
  },
  computed: {
    isOCRPGE: function () {
      return this.form.pgeType === 'OCR'
    },
    disableSubmit: function () {
      var disable = Object.values(this.form).filter(x => typeof x !== 'boolean').reduce((a, b) => a || (!b && b !== 0), false)

      if (this.EsRecibidas) {
        disable ||= this.form.fileMain.some(file => file.validations?.length || file.files?.some(efile => efile.validations?.length))
        disable ||= this.form.fileMain.some(file => file.warns?.some(warn => !warn.fixed) || file.files?.some(efile => efile.warns?.some(warn => !warn.fixed)))
        disable &&= this.isOCRPGE && !this.form.CifEmpresa
      } else {
        disable ||= this.form.fileMain.some(file => file.validations?.length || file.files?.some(efile => efile.validations?.length))
        disable ||= this.form.fileMain.some(file => file.warns?.some(warn => !warn.fixed) || file.files?.some(efile => efile.warns?.some(warn => !warn.fixed)))
        disable &&= this.isZCPGE && !this.form.CifEmpresa
      }
      return this.isLoadingUpdate || disable
    },
    isCifEmisorLoading: function () {
      return !!(this.loading || (this.isZCPGE && this.isSuperAdminOrDistributor && !this.form.ClienteID))
    },
    cifEmisorLoadingText: function () {
      return this.isZCPGE && !this.form.ClienteID ? i18n.t('validation.wait_idcliente') : undefined
    },
    isZCPGE: function () {
      return this.schemasFiles.ZCPGE > 0
    },
    isSuperAdminOrDistributor: function () {
      return this.role === 8 || this.role === 3
    },
    form: function () {
      return this.EsRecibidas ? this.receivedForm : this.issuedForm
    },
    rules: function () {
      return this.EsRecibidas ? this.receivedRules : this.issuedRules
    },
    clientFilter: function () {
      return this.$store.getters['app/idClienteFilterUpload']?.idCliente
    },
    ocrUploadLimitComputed: function () {
      return this.form.fileMain.some(x => this.getExtensionFromFileName(x.name).toUpperCase() === 'ZIP') ? 1 : this.ocrUploadLimit
    },
    pgeUploadLimitComputed: function () {
      return this.form.fileMain.some(x => this.getExtensionFromFileName(x.name).toUpperCase() === 'ZIP') ? 1 : this.pgeUploadLimit
    },
    maxFilesAdjWithRequired: function () {
      return this.expandedFiles.reduce((a, b) => a + (b.reqAttachments?.length || 0), this.maxFilesAdj)
    },
    receivedAcceptFiles: function () {
      const exts = this.fileNamesMain.map(name => this.getExtensionFromFileName(name).toUpperCase())

      if (this.isOCRPGE) {
        if (exts.length === 0) {
          return 'application/pdf,.zip'
        }
        return exts.some(x => x === 'PDF') ? 'application/pdf' : '.zip'
      } else {
        return '.xml,.xsig'
      }
    },
    pgeAcceptFiles: function () {
      const exts = this.fileNamesMain.map(name => this.getExtensionFromFileName(name).toUpperCase())
      if (exts.length === 0) {
        return '.xml,.xsig,.txt,.zip'
      }
      return exts.some(x => ['XML', 'XSIG', 'TXT'].includes(x)) ? '.xml,.xsig,.txt' : '.zip'
    },
    disableAdjuntosExternos () {
      return this.form.pgeType === 'OSAKIDETZA'
    },
    disableAdjuntos () {
      return this.form.pgeType === 'OCR'
    },
    acceptAdjuntosExternos () {
      if (this.form.pgeType === 'FACEB2B') return '.xml,.xsig,application/pdf,application/zip'
      return '.pdf,.html'
    },
    maxMBAdj () {
      return (this.EsRecibidas ? this.maxApsSizeFile : this.maxSizeFile) / 1024 / 1024
    },
    extensionRuleMessage: function () {
      if (this.form.pgeType === 'FACEB2B') {
        return `${i18n.t('validation.not_extension', { exts: this.extensionesAdjuntosFaceb2b.join(', ') })} ${i18n.t('validation.onlyonce_zip')}`
      }
      return i18n.t('validation.not_extension', { exts: this.extensionesAdjuntosPermitidas.join(', ') })
    },
    extensionTooltipMessage: function () {
      // if (this.multiSend) {
      //   return [i18n.t('validation.no_attachments_multiple_upload')]
      // }
      var maxFileMsg = this.form.pgeType === 'FACEB2B' ? i18n.t('validation.max_files_faceb2b', { maxFilesAdj: this.maxFilesAdj }) : i18n.t('validation.max_files', { maxFilesAdj: this.maxFilesAdj })
      var maxSizeMsg = i18n.t('validation.max_size_files', { maxMBAdj: this.maxMBAdj })
      var lines = [maxFileMsg + ' ' + maxSizeMsg]
      if (this.form.pgeType === 'FACEB2B') {
        lines.push(i18n.t('validation.extension', { exts: this.extensionesAdjuntosFaceb2b.join(', ') }))
      } else {
        lines[0] += ' ' + i18n.t('validation.extension', { exts: this.extensionesAdjuntosPermitidas.join(', ') })
      }
      if (this.disableAdjuntosExternos) {
        lines.push(i18n.t('invoices.dialogs.remove_facturae_sign_advice'), i18n.t('invoices.dialogs.embeded_atachments_advice'))
      }
      return lines
    },
    extensionTooltipFacturaeMessage: function () {
      const exts = this.fileNamesMain.map(name => this.getExtensionFromFileName(name).toUpperCase())
      const validExts = exts.length === 0 ? [...this.extensionesFacturaePermitidas, 'ZIP'] : (exts.some(x => x === 'ZIP') ? ['ZIP'] : this.extensionesFacturaePermitidas)
      return `${i18n.t('tooltip.total_max_size_files', { maxMB: this.maxMBAdj })} ${i18n.t('validation.extension', { exts: validExts.join(', ') })}`
    },
    extensionTooltipFacturaApsMessage: function () {
      const exts = this.fileNamesMain.map(name => this.getExtensionFromFileName(name).toUpperCase())
      const validExts = ['XML', 'XSIG']
      if (this.form.pgeType === 'OCR') {
        validExts.length = 0
        validExts.push(...(exts.length === 0 ? ['PDF', 'ZIP'] : (exts.some(x => x === 'ZIP') ? ['ZIP'] : ['PDF'])))
      }
      return `${i18n.t('tooltip.total_max_size_files', { maxMB: this.maxMBAdj })} ${i18n.t('validation.extension', { exts: validExts.join(', ') })}`
    },
    isLower1024: function () {
      return this.$store.getters['app/getIsLower1024']
    },
    ifFormEmpty: function () {
      return this.form === undefined || this.form === undefined
    },
    getIdEmpresaLogged: function () {
      return this.$store.getters['auth/user'].idCliente
    },
    role: function () {
      return this.$store.getters['auth/role']
    },
    fileNameMain () {
      const n = this.form.fileMain?.length ?? 0
      if (n === 0) {
        return ''
      } else if (n === 1) {
        return this.form.fileMain[0].name
      } else {
        return i18n.tc('app.n_files', n)
      }
    },
    fileName () {
      const filter = x => x.linkedfile?.linkid === this.selectedFile?.linkid && x.linkedfile?.uid === this.selectedFile?.uid
      const n = this.form.file?.filter(filter).length ?? 0
      if (n === 0) {
        return ''
      } else if (n === 1) {
        return this.form.file.find(filter).name
      } else {
        return i18n.tc('app.n_files', n)
      }
    },
    fileNamesMain () {
      if (this.form.fileMain === null) {
        return []
      }
      return this.form.fileMain.map(x => x.name)
    },
    attachmentsText () {
      if (this.selectedFile?.path) {
        return !this.disableAdjuntosExternos ? this.$t('invoices.documents_adj_ext_of', { name: this.selectedFile.path }) : this.$t('invoices.documents_adj_of', { name: this.selectedFile.path })
      }
      if (this.selectedFile?.name) {
        return !this.disableAdjuntosExternos ? this.$t('invoices.documents_adj_ext_of', this.selectedFile) : this.$t('invoices.documents_adj_of', this.selectedFile)
      }
      return !this.disableAdjuntosExternos ? this.$t('invoices.documents_adj_ext') : this.$t('invoices.documents_adj')
    },
    allAttachmentsText () {
      return !this.disableAdjuntosExternos ? this.$t('invoices.all_documents_adj_ext') : this.$t('invoices.all_documents_adj')
    },
    allAttachmentsListClass () {
      if (this.isLower1024) {
        return { 'grid-cols-3': true }
      }
      return { 'grid-cols-2': !!this.selectedFile, 'grid-cols-3': !this.selectedFile }
    },
    hasIOCRModule: function () {
      return this.$store.getters['auth/hasOCRIntegrationModule']
    },
    hasAutoFacturaModule: function () {
      return this.$store.getters['auth/hasAutofacturaModule']
    },
    multiSend: function () {
      return (this.form.fileMain.length > 1 || this.form.fileMain.some(f => this.getExtensionFromFileName(f.name).toUpperCase() === 'ZIP'))
    },
    attachments: function () {
      const attachments = []
      const items = this.form.file.filter(x => !this.form.fileMain.find(y => y.uid === x.linkedfile.uid)?.validations?.length)
      for (const item of items) {
        const attachment = { tooltip: item.linkedfile?.path || item.linkedfile?.name }
        for (const key in item) {
          this.$set(attachment, key, item[key])
        }
        this.$set(attachments, attachments.length, attachment)
      }
      return attachments
    },
    expandedFiles: function () {
      var files = this.form.fileMain
      while (!files.every(x => !x.files?.length)) {
        files = files.filter(x => !x.files?.length).concat(files.filter(x => x.files?.length).flatMap(x => x.files))
      }
      return files
    },
    parentFiles: function () {
      var parents = []
      var files = this.form.fileMain
      while (!files.every(x => !x.files?.length)) {
        parents.push(...files.filter(x => x.files?.length))
        files = files.filter(x => !x.files?.length).concat(files.filter(x => x.files?.length).flatMap(x => x.files))
      }
      return Object.assign([], parents)
    },
    pgeTypes: function () {
      return this.$store.getters['config/TIPOS_PGE']
    },
    pgeTypesRecepcion: function () {
      const tiposPges = this.$store.getters['config/TIPOS_PGE_RECEPCION']
      const pges = [tiposPges.find(x => x.id === 'MANUAL')]
      if (this.hasAutoFacturaModule) {
        pges.push(tiposPges.find(x => x.id === 'AUTOFACTURA'))
      }
      if (this.hasIOCRModule) {
        pges.push(tiposPges.find(x => x.id === 'OCR'))
      }
      return pges
    },
    receivedPgeTooltip: function () {
      const modules = []
      const tiposPges = this.$store.getters['config/TIPOS_PGE_RECEPCION']
      if (!this.hasAutoFacturaModule) {
        modules.push(tiposPges.find(x => x.id === 'AUTOFACTURA').name)
      }
      if (!this.hasIOCRModule) {
        modules.push(tiposPges.find(x => x.id === 'OCR').name)
      }
      return i18n.tc('tooltip.received_pge_warn', modules.length, { module: modules.join(', ') })
    }
  },
  methods: {
    onFileMainDrop (event) {
      [...event.dataTransfer.files].filter(file => !file.uid).forEach(file => this.handleChangeMain({ name: file.name, raw: file, status: 'ready' }))
    },
    onFileDrop (event) {
      [...event.dataTransfer.files].filter(file => !file.uid).forEach(file => this.handleChange({ name: file.name, raw: file, status: 'ready' }))
    },
    isFileLoading: function (file) {
      return !!file.loading
    },
    isFileError: function (file) {
      return !!(!(this.isFileLoading(file)) && file.validations?.length)
    },
    isFileWarn: function (file) {
      return !!(!(this.isFileLoading(file) || this.isFileError(file)) && file.warns?.length)
    },
    isFileSuccess: function (file) {
      return (!(this.isFileLoading(file) || this.isFileError(file) || this.isFileWarn(file)))
    },
    getExtensionFromFileName (fileName) {
      return fileName.split('.').at(-1)
    },
    calculateItemWidth: function () {
      if (this.$refs['upload-file-wrap']) {
        const el = this.$refs['upload-file-wrap'].$el || this.$refs['upload-file-wrap']
        this.itemWidth = `${el.offsetWidth}px`
      }
    },
    handleChangeClienteId: async function (ClienteID) {
      // const currentValue = this.form.ClienteID
      if (this.EsRecibidas) {
        if (ClienteID) {
          if (ClienteID !== this.OldClienteIdAPS) {
            this.updateClientAPSCifs(ClienteID)
          }
        } else {
          this.CifsEmpresaAPS = []
        }
        this.issuedForm.ClienteID = ClienteID || ''
        this.OldClienteIdAPS = ClienteID
      } else {
        if (ClienteID) {
          if (ClienteID !== this.OldClienteId) {
            if (this.isZCPGE) {
              this.updateClientCifs(ClienteID)
            }
            this.updateSchemaFiles(ClienteID)
          }
        } else {
          this.CifsEmpresa = []
        }
        this.receivedForm.ClienteID = ClienteID || ''
        this.OldClienteId = ClienteID
      }
    },
    handleChangeMain: async function (archivo) {
      (this.$refs.fileMainRef || this.$refs.fileReceivedMainRef).clearValidate()
      var fileOk = true
      const exts = this.fileNamesMain.map(name => this.getExtensionFromFileName(name).toUpperCase()).concat(this.getExtensionFromFileName(archivo.name).toUpperCase())
      if (exts.some(x => x === 'ZIP')) {
        if (exts.length > 1) {
          this.doFeedback(i18n.t('validation.onlyonce_zip'))
          this.handleRemoveMain(archivo)
          fileOk = false
        } else if (!this.EsRecibidas) {
          await this.checkSchemaZipFile(archivo)
        }
      } else if (!this.EsRecibidas) {
        if (!this.extensionesFacturaePermitidas.includes(this.getExtensionFromFileName(archivo.name).toUpperCase())) {
          this.doFeedback(i18n.t('validation.not_single_valid_extension', { ext: this.listToCommaString(['.xml', '.xsig', '.txt'], true) }))
          this.handleRemoveMain(archivo)
          fileOk = false
        } else {
          await this.checkSchemaFile(archivo)
          if ((this.form.fileMain.length + 1) === 1 && !archivo.files?.length && !archivo.validations?.length) {
            this.selectFile(archivo)
          }
        }
      } else if (this.EsRecibidas && !this.isOCRPGE) {
        if (!['XML'].includes(this.getExtensionFromFileName(archivo.name).toUpperCase())) {
          this.doFeedback(i18n.t('validation.not_single_valid_extension', { ext: '.pdf' }))
          this.handleRemoveMain(archivo)
          fileOk = false
        } else {
          await this.checkSchemaFile(archivo)
          if ((this.form.fileMain.length + 1) === 1 && !archivo.files?.length && !archivo.validations?.length) {
            this.selectFile(archivo)
          }
        }
      } else if (this.EsRecibidas && !['PDF'].includes(this.getExtensionFromFileName(archivo.name).toUpperCase())) {
        this.doFeedback(i18n.t('validation.not_single_valid_extension', { ext: '.pdf' }))
        this.handleRemoveMain(archivo)
        fileOk = false
      }
      
      if (fileOk) {
        this.form.fileMain.push(archivo)
      }
    },
    handleChange: function (archivo) {
      this.$refs.fileRef.clearValidate()

      const extension = this.getExtensionFromFileName(archivo.name).toUpperCase()
      var error = false
      if (this.form.pgeType === 'FACEB2B') {
        if (!this.extensionesAdjuntosFaceb2b.includes(extension)) {
          error = i18n.t('validation.not_valid_extension', { exts: this.extensionesAdjuntosFaceb2b.join(', ') })
        }
        if ((extension === 'ZIP' || this.form.file.map(x => this.getExtensionFromFileName(x.name).toUpperCase()).includes('ZIP')) && this.form.file.length >= 1) {
          error = i18n.t('validation.not_faceb2b_zip')
        }
      } else {
        if (!this.extensionesAdjuntosPermitidas.includes(extension)) {
          error = i18n.t('validation.not_valid_extension', { exts: this.extensionesAdjuntosPermitidas.join(', ') })
        }
      }
      if (error && error !== '') {
        this.doFeedback(error)
        this.handleRemove(archivo)
      } else {
        if (this.selectedFile) {
          this.$set(archivo, 'linkedfile', this.selectedFile)
        } else if (this.form.fileMain.length === 1) {
          this.$set(archivo, 'linkedfile', this.form.fileMain[0])
        }
        const mainFile = this.expandedFiles.find(x => x.linkid === archivo.linkedfile.linkid && x.uid === archivo.linkedfile.uid)
        if (mainFile?.reqAttachments?.some(x => x.AttachmentFormalName === archivo.name)) {
          const requireds = mainFile.reqAttachments.filter(x => x.AttachmentFormalName === archivo.name)
          const attachment = this.issuedForm.file.find(x => requireds.some(required => x.attachmentid === required.UniqueIdentifierAttachment) && !x.raw)
          if (attachment) {
            this.$set(attachment, 'successmsg', archivo?.name)
            this.$set(attachment, 'showinfo', !archivo?.raw)
            this.$set(attachment, 'raw', archivo.raw)
            this.expandedFiles.filter(x => x.linkid === attachment.linkedfile.linkid).forEach(x => this.$set(x, 'showinfo', this.form.file.filter(att => att.linkedfile.linkid === x.linkid).some(att => att.showinfo)))
            this.updateAttachmentWarningStatus(WarningType.MISSING_ATTACHMENT, !!archivo.raw, file => file.attachmentid === attachment.attachmentid, warn => warn.attachmentid === attachment.attachmentid)
            this.handleRemove(archivo)
          } else {
            const attachmentExt = this.getExtensionFromFileName(requireds[0].UniqueIdentifierAttachment)
            const attachmentKey = requireds[0].UniqueIdentifierAttachment.substring(0, requireds[0].UniqueIdentifierAttachment.lastIndexOf('.'))
            const attachmentCount = this.form.file.filter(x => x.name === archivo.name && x.linkedfile.linkid === archivo.linkedfile.linkid && x.linkedfile.uid === archivo.linkedfile.uid).length
            this.$set(archivo, 'attachmentid', `${attachmentKey}_${attachmentCount}.${attachmentExt}`)
            this.$set(archivo, 'origin', `user.${archivo.uid}`)
            this.form.file.push(archivo) 
          }
        } else {
          this.$set(archivo, 'origin', `user.${archivo.uid}`)
          this.form.file.push(archivo) 
        }
      }
    },
    handleOnExceedMain: function () {
      this.doFeedback(i18n.t('validation.max_files_warn', { limit: this.EsRecibidas ? this.ocrUploadLimitComputed : this.pgeUploadLimitComputed }), 'warning')
    },
    handleOnExceed: function () {
      this.doFeedback(i18n.t('validation.max_files_warn', { limit: this.maxFilesAdj }), 'warning')
    },
    handleRemoveMain: function (file) {
      if (this.EsRecibidas) {
        this.receivedForm.fileMain = this.form.fileMain.filter(x => x.uid !== file.uid)
      } else {
        if (file.esquema) {
          if (file.esquema === 'Variado') {
            if (file.files?.length) {
              file.files.forEach(x => { if (x.esquema) { this.schemasFiles[x.esquema] = Math.max(this.schemasFiles[x.esquema] - 1, 0) } })
            }
          } else {
            this.schemasFiles[file.esquema] = Math.max(this.schemasFiles[file.esquema] - 1, 0)
          }
        }
      }
      if (this.selectedFile?.linkid === file.linkid && this.selectedFile?.uid === file.uid) {
        this.selectedFile = null
      }
      if (file.files?.length) {
        for (const efile of file.files) {
          if (this.selectedFile?.linkid === efile.linkid && this.selectedFile?.uid === efile.uid) {
            this.selectedFile = null
          }
          // this.form.file.filter(x => x.linkedfile.uid === efile.uid).forEach(x => this.handleRemove(x))
        }
      }
      this.form.file.filter(x => x.linkedfile.uid === file.uid).forEach(x => this.handleRemove(x))
      this.form.fileMain = this.form.fileMain.filter(x => x.uid !== file.uid)
      const duplicated = this.form.fileMain.filter(x => x.linkid === file.linkid)
      if (duplicated.length) {
        if (duplicated.every(x => x.validations?.some(v => v.type === ErrorType.DUPLICATED_FILE))) {
          this.$set(duplicated[0], 'validations', duplicated[0].validations?.filter(v => v.type !== ErrorType.DUPLICATED_FILE))
        }
      }
    },
    handleRemove: function (file) {
      this.form.file = this.form.file.filter(x => x.uid !== file.uid)
    },

    // #region CheckSchema Methods

    updateSchemaFiles: function (ClienteID) {
      this.form.fileMain?.length && this.form.fileMain.forEach(file => this.getExtensionFromFileName(file.name).toLowerCase() === 'zip' ? this.checkSchemaZipFile(file, ClienteID) : this.checkSchemaFile(file, ClienteID))
    },
    checkSchemaFile: async function (archivo, idCliente = this.form.ClienteID) {
      this.$set(archivo, 'loading', true)
      try {
        const params = {}
        if ([3, 8].includes(this.role)) {
          params.idCliente = idCliente
        }
        const response = await getTipoEsquema([archivo], params)
        if (response.blnError) {
          const msg = `${response.msgError} [${response.codError}]`
          this.doFeedback(msg)
          this.$set(archivo, 'validations', [{ errorPath: msg, validationMessage: msg, type: ErrorType.API_RESPONSE_ERROR }])
          this.selectFile(archivo, true)
        } else if (!response.respuesta?.length) {
          this.doFeedback(i18n.t('feedback.error.can_not_validate_file_error'))
          const msg = i18n.t('feedback.error.not_validated_file_error')
          this.$set(archivo, 'validations', [{ errorPath: msg, validationMessage: msg, type: ErrorType.GENERIC_ERROR }])
          this.selectFile(archivo, true)
        } else {
          const file = response.respuesta[0]
          this.$set(file, 'origin', `user.file.${file.uid}`)
          this.checkSchemaFileResponse(archivo, file) 
        }
      } catch (error) {
        let path = ''; let msg = ''; let type = ErrorType.GENERIC_ERROR
        if (error.isntGeneric) {
          msg = error.message
          path = error.path || msg
        } else if (error.code === 'ECONNABORTED') {
          msg = i18n.t('feedback.error.timeout_error_message')
          path = error.message
          type = ErrorType.API_TIMEOUT_ERROR
        } else {
          msg = i18n.t('feedback.error.internal_error_message')
          path = msg
        }
        this.doFeedback(msg)
        this.$set(archivo, 'validations', [{ errorPath: path, validationMessage: msg, type: type }])
      }
      this.$set(archivo, 'loading', false)
    },
    checkSchemaZipFile: async function (archivo, idCliente = this.form.ClienteID) {
      this.$set(archivo, 'loading', true)
      const params = {}
      if ([3, 8].includes(this.role)) {
        params.idCliente = idCliente
      }
      const response = await getTipoEsquema([archivo], params)
      const zipFiles = []
      if (response.blnError) {
        const msg = `${response.msgError} [${response.codError}]`
        this.doFeedback(msg)
        this.$set(archivo, 'validations', [{ errorPath: msg, validationMessage: msg, type: ErrorType.API_RESPONSE_ERROR }])
        this.selectFile(archivo, true)
      } else if (!response.respuesta?.length) {
        this.doFeedback(i18n.t('feedback.error.can_not_validate_zip_error'))
        const msg = i18n.t('feedback.error.not_validated_file_error')
        this.$set(archivo, 'validations', [{ errorPath: msg, validationMessage: msg, type: ErrorType.GENERIC_ERROR }])
        this.selectFile(archivo, true)
      } else {
        var hasErrors = false; var hasWarns = false
        this.$set(archivo, 'linkid', 'ZIPFILE')
        this.$set(archivo, 'origin', `user.zip.${archivo.uid}`)
        for (const file of response.respuesta) {
          const zipFile = {}
          this.$set(zipFile, 'uid', archivo.uid)
          this.$set(zipFile, 'name', file.FileName)
          this.$set(zipFile, 'origin', `user.zipfile.${zipFile.uid}`)
          this.$set(zipFile, 'path', `${archivo.path || archivo.name}/${zipFile.name.includes('/') ? `"${zipFile.name}"` : zipFile.name}`)
          this.checkSchemaFileResponse(zipFile, file)
          this.$set(zipFiles, zipFiles.length, zipFile)
          hasErrors &&= zipFile.validations?.length
          hasWarns &&= zipFile.warns?.length
        }

        if (zipFiles.every(x => x.esquema === zipFiles[0].esquema)) {
          this.$set(archivo, 'esquema', zipFiles[0].esquema + 's')
        } else {
          this.$set(archivo, 'esquema', 'Variado')
        }
        if (archivo.esquema !== 'NO_VALID') {
          // this.$set(archivo, 'tooltip', archivo.esquema)
        }

        if (hasErrors) {
          setTimeout(() => this.doFeedback(`${archivo.name}: ${i18n.t('tooltip.issued_any_childfile_errors')}`), 100)
        }
        if (hasWarns) {
          setTimeout(() => this.doFeedback(`${archivo.name}: ${i18n.t('tooltip.issued_any_childfile_warns')}`), 100)
        }
      }
      this.$set(archivo, 'files', zipFiles)
      this.$set(archivo, 'isOpen', false)
      this.$set(archivo, 'loading', false)
    },
    checkSchemaFileResponse (archivo, fileData) {
      this.$set(archivo, 'validations', [])
      this.$set(archivo, 'warns', [])
      if (fileData.schemaValidationErrors?.length) {
        // for (const error of invoice.schemaValidationErrors) {
        //   setTimeout(() => this.doFeedback(`${invoice.FileName}: ${error.errorPath} ${error.validationMessage}`), 100)
        // }
        setTimeout(() => this.doFeedback(`${fileData.FileName}: ${i18n.t('feedback.error.schema_validation_error')}`), 100)
        this.$set(archivo, 'validations', fileData.schemaValidationErrors.map(x => ({ ...x, type: ErrorType.SCHEMA_VALIDATION_ERROR })))
        this.selectFile(archivo, true)
      }

      if (fileData.esquema !== 'FACTURAE' && this.EsRecibidas && !this.isOCRPGE) {
        const msg = `${fileData.FileName}: ${i18n.t('feedback.error.not_valid_schema_for_error', { pge: this.form.pgeType })}`
        setTimeout(() => this.doFeedback(msg), 100)
        this.$set(archivo, 'validations', [{ errorPath: msg, validationMessage: msg, type: ErrorType.GENERIC_ERROR }])
        this.selectFile(archivo, true)
        return
      }

      if (fileData.esquema === 'ZCPGE') {
        if (!this.form.CifEmpresa) {
          setTimeout(() => this.doFeedback(`${fileData.FileName}: ${i18n.t('feedback.info.without_issuer_data_msg')}`, 'info'), 100)
          this.$set(archivo, 'warns', [...(archivo.warns || []), { warnMessage: i18n.t('tooltip.issued_zcpge_warn'), type: WarningType.MISSING_CIF, fixed: false }])
        }
      }
      this.$set(archivo, 'esquema', fileData.esquema)
      if (archivo.esquema !== 'NO_VALID') {
        // this.$set(archivo, 'tooltip', archivo.esquema)
      }
      if (!fileData.FileDetails) {
        if (!fileData.schemaValidationErrors?.length) {
          const msg = i18n.t('feedback.error.schema_validation_error')
          setTimeout(() => this.doFeedback(`${fileData.FileName}: ${msg}`), 100)
          this.$set(archivo, 'validations', [...(archivo.validations || []), { errorPath: msg, validationMessage: msg, type: ErrorType.GENERIC_ERROR }])
          this.selectFile(archivo, true)
        }
      } else {
        this.$set(archivo, 'linkid', fileData.FileDetails.SHA1_ID)
        if (this.issuedForm.fileMain.some(x => x.linkid === archivo.linkid && x !== archivo)) {
          const msg = i18n.t('feedback.error.duplicated_file_error')
          setTimeout(() => this.doFeedback(`${fileData.FileName}: ${msg}`), 100)
          this.$set(archivo, 'validations', [...(archivo.validations || []), { errorPath: msg, validationMessage: msg, type: ErrorType.DUPLICATED_FILE }])
          this.selectFile(archivo, true)
        }
        if (!fileData.FileDetails.InvoicesToImport || fileData.FileDetails.InvoicesToImport <= 0) {
          const msg = i18n.t('feedback.error.empty_invoice_file_error')
          setTimeout(() => this.doFeedback(`${fileData.FileName}: ${msg}`), 100)
          this.$set(archivo, 'validations', [...(archivo.validations || []), { errorPath: msg, validationMessage: msg, type: ErrorType.EMPTY_INVOICE_FILE }])
          this.selectFile(archivo, true)
        } else if (fileData.FileDetails.InvoicesToImport !== fileData.FileDetails.Invoices.length) {
          const msg = i18n.t('feedback.error.not_valid_invoice_number_error')
          setTimeout(() => this.doFeedback(`${fileData.FileName}: ${msg}`), 100)
          this.$set(archivo, 'validations', [...(archivo.validations || []), { errorPath: msg, validationMessage: msg, type: ErrorType.INVALID_INVOICE_COUNT_ERROR }])
          this.selectFile(archivo, true)
        } else if (fileData.FileDetails.InvoicesToImport === 1) {
          const invoice = fileData.FileDetails.Invoices[0]
          this.$set(archivo, 'attachid', `${archivo.linkid}_${invoice.UniqueIdentifierInvoice}`)
          this.$set(archivo, 'reqAttachments', invoice.RequestedAttachments)
          this.checkAttachmentsFileResponse(archivo, invoice.RequestedAttachments)
        } else {
          this.$set(archivo, 'files', [])
          this.$set(archivo, 'isOpen', false)
          for (const invoice of fileData.FileDetails.Invoices) {
            const innerfile = {}
            this.$set(innerfile, 'linkid', `${archivo.linkid}_${invoice.UniqueIdentifierInvoice}`)
            this.$set(innerfile, 'uid', archivo.uid)
            this.$set(innerfile, 'origin', `user.api.invoice.${innerfile.uid}`)
            this.$set(innerfile, 'name', `${invoice.InvoiceSeries}_${invoice.InvoiceNumber}`)
            this.$set(innerfile, 'reqAttachments', invoice.RequestedAttachments)
            this.checkAttachmentsFileResponse(innerfile, invoice.RequestedAttachments)
            this.$set(archivo.files, archivo.files.length, innerfile)
          }
          if (archivo.files?.some(x => x.warns?.length)) {
            this.$set(archivo, 'warns', [...(archivo.warns || []), { warnMessage: i18n.t('tooltip.issued_any_childfile_warns'), type: WarningType.MIXED_WARNING, fixed: archivo.files.every(x => x.warns?.every(w => w.fixed)) }])
          }
        }
      }

      
      if (archivo.files?.length) {
        archivo.files.forEach((x, i, a) => this.$set(a[i], 'path', `${archivo.path || archivo.name}/${x.name.includes('/') ? `"${x.name}"` : x.name}`))
      }

      this.schemasFiles[archivo.esquema]++
    },
    checkAttachmentsFileResponse: function (archivo, attachments) {
      if (attachments?.length) {
        for (const attachment of attachments) {
          const msg = i18n.t('tooltip.issued_required_attachment_warn', { fileName: attachment.AttachmentFormalName })
          this.$nextTick(() => {
            const attachmentFile = { name: attachment.AttachmentFormalName, linkedfile: { linkid: archivo.linkid, uid: archivo.uid, attachid: archivo.attachid, name: archivo.name, path: archivo.path }, attachmentid: attachment.UniqueIdentifierAttachment, IsAlreadyProvided: attachment.IsAlreadyProvided, IsObligatory: attachment.IsObligatory, warns: [], origin: 'api', required: true }
            this.$set(attachmentFile, 'origin', `${attachmentFile.attachmentid}.${attachmentFile.origin}`)
            if (attachment.IsObligatory) {
              this.$set(attachmentFile.warns, attachmentFile.warns.length, { warnMessage: msg, type: WarningType.MISSING_ATTACHMENT, attachmentid: attachment.UniqueIdentifierAttachment, fixed: attachment.IsAlreadyProvided })
            } else if (!attachment.IsAlreadyProvided) {
              this.$set(attachmentFile, 'infomsg', i18n.t('tooltip.issued_optional_attachment_msg'))
              this.$set(attachmentFile, 'showinfo', true)
            }
            if (attachment.IsAlreadyProvided) {
              this.$set(attachmentFile, 'successmsg', i18n.t('tooltip.issued_included_attachment_msg'))
            }
            if (this.form.file.some(x => x.attachmentid === attachment.UniqueIdentifierAttachment)) {
              const attachmentIndex = this.form.file.findIndex(x => x.attachmentid === attachment.UniqueIdentifierAttachment)
              const oldAttachment = this.form.file[attachmentIndex]
              this.$set(attachmentFile, 'successmsg', oldAttachment?.name)
              this.$set(attachmentFile, 'showinfo', !oldAttachment.raw)
              this.$set(attachmentFile, 'raw', oldAttachment.raw)
              this.$set(this.form.file, attachmentIndex, attachmentFile)
              this.expandedFiles.filter(x => x.linkid === attachmentFile.linkedfile.linkid).forEach(x => this.$set(x, 'showinfo', this.form.file.filter(att => att.linkedfile.linkid === x.linkid).some(att => att.showinfo)))
              this.updateAttachmentWarningStatus(WarningType.MISSING_ATTACHMENT, !!attachmentFile.raw, file => file.attachmentid === attachmentFile.attachmentid, warn => warn.attachmentid === attachmentFile.attachmentid)
            } else {
              this.$set(this.form.file, this.form.file.length, attachmentFile)
            }
          })
          this.$set(archivo, 'warns', [...(archivo.warns || []), { warnMessage: msg, type: WarningType.MISSING_ATTACHMENT, attachmentid: attachment.UniqueIdentifierAttachment, fixed: attachment.IsAlreadyProvided || !attachment.IsObligatory }])
          if (archivo.reqAttachments?.some(x => !x.IsObligatory && !x.IsAlreadyProvided)) {
            this.$set(archivo, 'infomsg', i18n.t('tooltip.issued_some_optional_attachment_msg'))
            this.$set(archivo, 'showinfo', true)
          }
        }
      }
    },
    // #endregion

    selectFile: function (archivo, forceUnselect = false) {
      if (archivo?.linkid === this.selectedFile?.linkid && archivo.uid === this.selectedFile?.uid) {
        this.selectedFile = null
      } else if (!forceUnselect) {
        this.selectedFile = { name: archivo.name, path: archivo.path, linkid: archivo.linkid, uid: archivo.uid, attachid: archivo.attachid }
      }
    },
    selectRequiredFile: function (efile) {
      const ext = this.getExtensionFromFileName(efile.name).toUpperCase()
      var input = document.createElement('input')
      input.type = 'file'
      input.accept = `.${ext}`
      input.multiple = false
      input.onchange = function (event) {
        const attachment = this.form.file.find(x => x.attachmentid === efile.attachmentid)
        const file = event.target.files.item(0)
        if (!file || this.getExtensionFromFileName(file.name).toUpperCase() === ext) {
          this.$set(attachment, 'successmsg', file?.name)
          this.$set(attachment, 'showinfo', !file)
          this.$set(attachment, 'raw', file)
          this.expandedFiles.filter(x => x.linkid === attachment.linkedfile.linkid).forEach(x => this.$set(x, 'showinfo', this.form.file.filter(att => att.linkedfile.linkid === x.linkid).some(att => att.showinfo)))
          this.updateAttachmentWarningStatus(WarningType.MISSING_ATTACHMENT, !!file, file => file.attachmentid === attachment.attachmentid, warn => warn.attachmentid === attachment.attachmentid)
        } else {
          setTimeout(() => this.doFeedback(i18n.t('validation.not_single_valid_extension', { ext: `.${ext}` })), 100)
        }
      }.bind(this)
      input.oncancel = function (event) {
        this.clearRequiredFile(efile)
      }.bind(this)
      input.click()
    },
    clearRequiredFile: function (efile) {
      const attachment = this.form.file.find(x => x.attachmentid === efile.attachmentid)
      this.$set(attachment, 'successmsg', null)
      this.$set(attachment, 'showinfo', true)
      this.$set(attachment, 'raw', null)
      this.expandedFiles.filter(x => x.linkid === attachment.linkedfile.linkid).forEach(x => this.$set(x, 'showinfo', true))
      this.updateAttachmentWarningStatus(WarningType.MISSING_ATTACHMENT, !attachment.IsObligatory, file => file.attachmentid === attachment.attachmentid, warn => warn.attachmentid === attachment.attachmentid)
    },
    updateWarningStatus: function (type, value, filterF = file => true, filterW = warn => true) {
      const files = this.expandedFiles.filter(filterF)
      files.forEach(file => {
        const warnings = file.warns?.filter(warn => warn.type === type).filter(filterW) ?? []
        if (warnings.length) {
          warnings.forEach(warn => this.$set(warn, 'fixed', !!value))
          const parentFiles = this.parentFiles.filter(x => x.uid === file.uid && x.linkid !== file.linkid)
          parentFiles.forEach(x => x.warns?.filter(warn => warn.type === WarningType.MIXED_WARNING).forEach(warn => this.$set(warn, 'fixed', x.files?.every(y => y.warns?.every(w => w.fixed)))))
        }
      })
    },
    updateAttachmentWarningStatus: function (type, value, filterF = file => true, filterW = warn => true) {
      const attachments = this.attachments.filter(filterF)
      attachments.forEach(attachment => {
        const warnings = attachment.warns?.filter(warn => warn.type === type).filter(filterW) ?? []
        if (warnings.length) {
          warnings.forEach(warn => this.$set(warn, 'fixed', !!value))
          this.updateWarningStatus(type, value, file => file.linkid === attachment.linkedfile.linkid, warn => warn.attachmentid === attachment.attachmentid)
        }
      })
    },
    showAddAttachments: function (efile) {
      return !this.disableAdjuntos && !efile.files?.length && (this.isFileSuccess(efile) || this.isFileWarn(efile))
    },
    toggleDialog: function () {
      this.isOpen = !this.isOpen
      this.resetForm()
      this.$emit('toggleDialog')
    },
    resetForm () {
      this.clientes = []
      this.EsRecibidas = false
      this.issuedForm.ClienteID = ''
      this.receivedForm.ClienteID = ''
      this.resetIssuedForm()
      this.resetReceivedForm()
    },
    resetIssuedFormFiles () {
      if (this.$refs.uploadMain) this.$refs.uploadMain.clearFiles()
      if (this.$refs.upload) this.$refs.upload.clearFiles()
      this.issuedForm.fileMain = []
      this.issuedForm.file = []
    },
    resetReceivedFormFiles () {
      if (this.$refs.uploadReceivedMain) this.$refs.uploadReceivedMain.clearFiles()
      if (this.$refs.uploadReceived) this.$refs.uploadReceived.clearFiles()
      this.receivedForm.fileMain = []
      this.receivedForm.file = []
    },
    resetIssuedForm: function () {
      this.resetIssuedFormFiles()
      this.issuedForm.sendAuto = false
      this.issuedForm.sendMail = false
      this.issuedForm.pgeType = ''
      this.issuedForm.CifEmpresa = ''
      this.schemasFiles.ZCPGE = 0
      this.$refs.ruleForm.clearValidate()
    },
    resetReceivedForm: function () {
      this.resetReceivedFormFiles()
      this.receivedForm.CifEmpresa = ''
      this.receivedForm.pgeType = 'MANUAL'
      this.receivedForm.sendMail = false
      this.$refs.ruleForm.clearValidate()
    },
    initialiceData: async function () {
      if ([8, 3].includes(this.role)) {
        const dataClients = await getClients()
        if (dataClients.blnError === true) {
          this.doFeedback(`${dataClients.msgError} [${dataClients.codError}]`)
        }
        this.clientes = dataClients.Clientes.map(x => ({ label: x.Nombre, value: x.idCliente }))
        this.issuedForm.ClienteID = this.clientFilter || ''
        this.receivedForm.ClienteID = this.clientFilter || ''
      } else {
        this.issuedForm.ClienteID = this.getIdEmpresaLogged || ''
        this.receivedForm.ClienteID = this.getIdEmpresaLogged || ''
      }
      this.selectedFile = null
    },
    uploadInvoice: async function (ruleForm) {
      if (this.EsRecibidas) {
        this.uploadReceivedInvoice(ruleForm)
      } else {
        this.uploadIssuedInvoice(ruleForm)
      }
    },
    uploadIssuedInvoice: function (ruleForm) {
      try {
        this.$store.commit('setIsLoading', true)
        this.$refs[ruleForm].validate(async valid => {
          if (valid) {
            this.isLoadingUpdate = true
            let files
            if (this.disableAdjuntos/*  || this.multiSend */) {
              files = this.form.fileMain
            } else {
              files = this.form.fileMain.concat(this.form.file)
            }
            const params = {
              pgeType: this.form.pgeType || null,
              enviarAuto: !!this.form.sendAuto,
              enviarMail: !!this.form.sendMail,
              multiSend: !!this.multiSend,
              idCIFEmpresa: this.form.CifEmpresa || null,
              idCliente: 0,
            }
            if ([3, 8].includes(this.role)) {
              params.idCliente = this.form.ClienteID
            }
            if (this.multiSend) {
              subirFactura(files, params).then(response => {
                if (response.blnError === true) {
                  this.doFeedback(`${response.msgError} [${response.codError}]`, response.codError === 'FCSF012' ? 'warning' : 'error')
                } else {
                  this.doFeedback(i18n.tc('feedback.success.invoices_uploaded_msg', 2), 'success')
                }
                this.$emit('applyDialog', { results: response.Respuestas })
              }).catch(() => {
                this.doFeedback(i18n.t('feedback.error.internal_error_message'))
                this.$emit('applyDialog', {})
              }).finally(() => { this.isLoadingUpdate = false })
              this.resetIssuedForm()
              this.$emit('applyDialog', { background: true })
            } else {
              const response = await subirFactura(files, params)
              if (response.blnError === true) {
                this.doFeedback(`${response.msgError} [${response.codError}]`)
              } else {
                this.resetIssuedForm()
                this.$emit('applyDialog', {})
                this.doFeedback(i18n.tc('feedback.success.invoices_uploaded_msg', 1), 'success')
              }
              this.isLoadingUpdate = false
            }
          } else {
            this.doFeedback(i18n.t('feedback.error.process_data_error'))
          }
        })
      } catch (error) {
        this.isLoadingUpdate = false
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    uploadReceivedInvoice: function (ruleForm) {
      try {
        this.$store.commit('setIsLoading', true)
        this.$refs[ruleForm].validate(async valid => {
          if (!valid) {
            this.doFeedback(i18n.t('feedback.error.process_data_error'))
            return
          }
          this.isLoadingUpdate = true
          let files
          if (this.disableAdjuntos/*  || this.multiSend */) {
            files = this.form.fileMain
          } else {
            files = this.form.fileMain.concat(this.form.file)
          }
          const params = {
            idCIFEmpresa: this.form.CifEmpresa,
            pgeType: this.form.pgeType || 'MANUAL',
            multiSend: !!this.multiSend,
            enviarMail: !!this.form.sendMail,
            idCliente: 0,
          }
          if ([3, 8].includes(this.role)) {
            params.idCliente = this.form.ClienteID
          }
          if (params.pgeType === 'OCR') {
            if (this.multiSend) {
              subirFacturaAPS(files, params).then(response => {
                if (response.blnError === true) {
                  this.doFeedback(`${response.msgError} [${response.codError}]`, response.codError === 'FCSF012' ? 'warning' : 'error')
                } else {
                  this.doFeedback(i18n.tc('feedback.success.invoices_uploaded_msg', 1), 'success')
                }
                this.$emit('applyDialog', { results: response.Respuestas })
              }).catch(() => {
                this.doFeedback(i18n.t('feedback.error.internal_error_message'))
                this.$emit('applyDialog', {})
              }).finally(() => { this.isLoadingUpdate = false })
              this.resetReceivedForm()
              this.$emit('applyDialog', { background: true })
            } else {
              const response = await subirFacturaAPS(files, params)
              if (response.blnError === true) {
                this.doFeedback(`${response.msgError} [${response.codError}]`)
              } else {
                this.resetReceivedForm()
                this.$emit('applyDialog', {})
                this.doFeedback(i18n.tc('feedback.success.invoices_uploaded_msg', 1), 'success')
              }
              this.isLoadingUpdate = false
            }
          } else {
            if (this.multiSend) {
              subirFacturaRecibida(files, params).then(response => {
                if (response.blnError === true) {
                  this.doFeedback(`${response.msgError} [${response.codError}]`, response.codError === 'FCSF012' ? 'warning' : 'error')
                } else {
                  this.doFeedback(i18n.tc('feedback.success.invoices_uploaded_msg', 1), 'success')
                }
                this.$emit('applyDialog', { results: response.Respuestas })
              }).catch(() => {
                this.doFeedback(i18n.t('feedback.error.internal_error_message'))
                this.$emit('applyDialog', {})
              }).finally(() => { this.isLoadingUpdate = false })
              this.resetReceivedForm()
              this.$emit('applyDialog', { background: true })
            } else {
              const response = await subirFacturaRecibida(files, params)
              if (response.blnError === true) {
                this.doFeedback(`${response.msgError} [${response.codError}]`)
              } else {
                this.resetReceivedForm()
                this.$emit('applyDialog', {})
                this.doFeedback(i18n.tc('feedback.success.invoices_uploaded_msg', 1), 'success')
              }
              this.isLoadingUpdate = false
            }
          }
        })
      } catch (error) {
        this.isLoadingUpdate = false
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    updateClientCifs: async function (idCliente) {
      this.loading = true
      this.$store.commit('setIsLoading', true)
      const res = await getAllCompanies({ idCliente })
      if (res.blnError) {
        this.doFeedback(`${res.msgError} [${res.codError}]`)
        this.CifsEmpresa = []
      } else {
        this.CifsEmpresa = res.CIFSEmpresa.map(x => ({ label: x.RazonSocial, value: x.IdCIFEmpresa }))
      }
      this.loading = false
      this.$store.commit('setIsLoading', false)
    },
    updateClientAPSCifs: async function (idCliente) {
      this.loading = true
      this.$store.commit('setIsLoading', true)
      this.form.CifEmpresa = ''
      const res = await getAvailableCifsAPS({ idCliente })
      if (res.blnError) {
        this.doFeedback(`${res.msgError} [${res.codError}]`)
        this.CifsEmpresaAPS = []
      } else {
        this.CifsEmpresaAPS = res.CIFSEmpresa.map(x => ({ label: x.RazonSocial, value: x.IdCIFEmpresa }))
      }
      this.loading = false
      this.$store.commit('setIsLoading', false)
    },
  }
}
</script>

<style lang="scss" scoped>
.center {
  margin: auto;
  width: 60%;
  border: none;
  padding: 1px;
}

.all-attachments-container .upload-file-list ::v-deep .upload-file-list--item {
  margin-top: unset;
  margin-bottom: unset;
}
.main-files-container, .file-attachments-container {
  height: fit-content;
}
.all-attachments-container {
  max-height: 345px;
}

@media (min-width: 1024px) {
  .all-attachments-container .upload-file-list.grid-cols-2 {
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }
  .all-attachments-container .upload-file-list.grid-cols-3 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
@media (min-width: 1680px) {
  .all-attachments-container .upload-file-list.grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .all-attachments-container .upload-file-list.grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}
</style>
